import type { FunctionComponent, KeyboardEvent, RefObject } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { PromptComposer } from '~/ui/domain/PromptComposer/PromptComposer';

import { TranscribableTextarea } from '../../components/TranscribableTextarea';

type CommentReplyComposerProps = {
    readonly inputRef: RefObject<HTMLTextAreaElement | null>;
    readonly isActive: boolean;
    readonly replyBody: string;
    readonly submitDisabled?: boolean;
    readonly onCancel: () => void;
    readonly onKeyDown: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
    readonly onReplyBodyChange: (value: string) => void;
    readonly onSubmit: () => void;
};

export const CommentReplyComposer: FunctionComponent<CommentReplyComposerProps> = ({
    inputRef,
    isActive,
    onCancel,
    onKeyDown,
    onReplyBodyChange,
    onSubmit,
    replyBody,
    submitDisabled = false,
}) => {
    const translate = useTranslate();

    return (
        <PromptComposer
            cancelLabel={translate('common.cancel')}
            mode="inline"
            submitDisabled={submitDisabled || replyBody.trim().length === 0}
            submitLabel={translate('pages.job-architecture-v2.comments.thread.reply-submit')}
            onCancel={onCancel}
            onSubmit={onSubmit}
        >
            <TranscribableTextarea
                ref={inputRef}
                autoResize={true}
                maxRows={4}
                placeholder={
                    isActive ? translate('pages.job-architecture-v2.comments.thread.reply-placeholder') : undefined
                }
                rows={2}
                tabIndex={isActive ? undefined : -1}
                textareaClassName="min-h-[52px]"
                value={replyBody}
                onKeyDown={onKeyDown}
                onValueChange={onReplyBodyChange}
            />
        </PromptComposer>
    );
};
